import { PaginationTable, TableWrapper } from 'components/Global';
import React from 'react';
import DriverReviewItem from './driver-review-item';
import { useSelector } from 'react-redux';

export const imageColorList = [
  '#F7B23B',
  '#4C4DDC',
  '#21B24B',
  '#BE1833',
  '#5BE182',
  '#D2364F',
  '#008CEB',
  '#FF5F00',
  '#00AED6',
  '#FFBE9D',
];

const DriverReview = ({ currentPage, setCurrentPage }) => {
  const reviewData = useSelector((state) => state.drivers.reviews);

  return (
    <TableWrapper title="Review Driver">
      <div className="driver__review-driver">
        {reviewData?.data?.length > 0 ? (
          reviewData?.data.map((item, index) => (
            <DriverReviewItem key={item.id} reviewData={item} bgColor={imageColorList[index % 10]} type="driver" />
          ))
        ) : (
          <div className="driver__review-driver__empty">
            <p>Belum Ada Data Review</p>
          </div>
        )}
      </div>
      <PaginationTable
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
        totalCount={reviewData?.pagination?.total}
      />
    </TableWrapper>
  );
};

export default DriverReview;
